module.exports = __webpack_public_path__ + "img/incident-icon.3c0f7d75.svg";